
<template>
  <line
    v-for="index in numDashes"
    :x1="Math.min(dashInterval * (index - 1), width)"
    :y1="yPixel"
    :x2="Math.min(dashInterval * (index - 0.5), width)"
    :y2="yPixel"
    :style="getLineStyle"
  />
  <text :y="yPixel - 5" :x="LegendLoc" class="rm-text" :style="getTextStyle">{{ LegendName }}</text>
</template>

<script>
import { useInputStore } from '@/store/InputStore';
import { useSettingsStore } from '@/store/SettingsStore';
import * as UnitConversion from '@/services/UnitConversionService';

export default {
  name: 'RangeMarker',
  props: [
    'color',
    'type',
    'value',
    'num'
  ],
  data () {
    return {
      numDashes: 50
    };
  },
  computed: {
    LegendLoc () {
      if (this.$props.type === 'pressure') {
        return 30;
      } else if (this.$props.type === 'flow') {
        return this.width - 60;
      }
    },
    LegendName () {
      return this.$props.num === 0 ? 'min ' : 'max ';
    },
    dashInterval () {
      return this.width / this.numDashes;
    },
    yPixel () {
      const settingsStore = useSettingsStore();
      let value = 0;
      if (this.$props.type == 'pressure') {
        value = UnitConversion.UnfilterPressure(this.$props.value, settingsStore.getPressureUnit);
      } else if (this.$props.type == 'flow') {
        value = UnitConversion.UnfilterEmitterFlow(this.$props.value, settingsStore.getFlowUnit);
      }
      let y = useInputStore().mapMinMaxRange(value, this.$props.type);
      return Number.isFinite(y) ? y : '0';
    },
    width () {
      return useInputStore().getPressureFlowChartWidth;
    },
    getTextStyle () {
      return 'fill: ' + this.color + ';';
    },
    getLineStyle () {
      return 'stroke: ' + this.color + ';';
    }
  },
};
</script>

<style scoped>
.rm-text {
  font-weight: bold;
  font-size: 14px;
}
</style>